import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  REPO_API,
} from '../Core';
import { FindLocationType } from '../Types/GeoLocation.types';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/location';
export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
export const URL_POSTMAN = `${REPO_API}/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/e3d0c1f9-e149-4b08-b6de-325df482b8c7?version=b9da0ff0-3fa6-47af-a2b3-53416c5a1746&tab=overview`;
export const LANGUAGE_DEFAULT = 'pt-BR';

export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (requestParams: {
  locationType: FindLocationType;
  input: string;
  language?: string;
}): Promise<IFinalResponse> => {
  const params: {
    type: string;
    langague?: string;
    input?: string;
    address?: string;
    placeId?: string;
    product?: string;
  } = {
    type: requestParams.locationType.toLowerCase(),
  };

  switch (requestParams.locationType) {
    case 'GEOLOCATION':
      params.address = requestParams.input;
      delete params.input;
      break;
    case 'DETAIL':
      params.placeId = requestParams.input;
      delete params.input;
      break;
    case 'PLACES':
      params.product = 'hotel';
      params.input = requestParams.input;
      break;
    default:
      params.input = requestParams.input;
      break;
  }

  const init: InitApiType = {
    params,
  };

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const call = { get: callGet };

export default { call, definitions };
